import axios from 'axios'

const state = {
    status: '',
    accessToken: localStorage.getItem('access_token') || '',
    activeUser: JSON.parse(localStorage.getItem('active_user')) || {},
    freshLogin: false,
    notActivated: false,
  };

const getters = {
    isLoggedIn: state => !!state.accessToken,
    accessToken: state => state.accessToken,
    authStatus: state => state.status,
    activeUser: state => state.activeUser,
    isAdminUser: state => {
      if (state.activeUser != {} && state.activeUser.is_staff == true){
        return true
      } else {
        return false
      }
    },
    freshLogin: state => state.freshLogin,
    notActivated: state => state.notActivated
}

const actions = {
    login: ({commit}, creds) => {
        return new Promise((resolve, reject) => {
            commit('LOADING')
            axios({method: 'post', url: 'auth/obtain_token/', data:creds})
            .then(resp => {
                let token = resp.data.token
                let user = resp.data.user
                if (!user.is_staff && user.advertiser_id === 'N/A'){
                    localStorage.removeItem('access_token')
                    commit('NOT_ACTIVATED')
                } else {
                    localStorage.setItem('access_token', token)
                    localStorage.setItem('active_user', JSON.stringify(user))
                    axios.defaults.headers.common['Authorization'] = 'JWT ' + token
                    commit('AUTH_SUCCESS', token)
                    commit('SAVE_USER', user)
                }
                resolve(resp)
            })
            .catch(err => {
                commit('AUTH_ERROR')
                localStorage.removeItem('access_token')
                // localStorage.removeItem('active_user')
                reject(err)
            })
        })
    },
    logout: ({commit}) => {
        commit('LOGOUT')
        commit('STALE_ENTITIES')
        localStorage.removeItem('access_token')
        // localStorage.removeItem('active_user')
        delete axios.defaults.headers.common['Authorization']
    },
}

const mutations = {
    LOADING: (state) => {
        state.status = 'loading'
    },
    AUTH_SUCCESS: (state, token) => {
        state.status = 'success'
        state.accessToken = token
        state.notActivated = false
    },
    AUTH_ERROR: (state) => {
        state.status = 'error'
    },
    LOGOUT: (state) => {
        state.status = ''
        state.accessToken = ''
        state.activeUser = {}
        state.freshLogin = true
    },
    SAVE_USER: (state, active_user) =>{
        state.activeUser = active_user
        state.freshLogin = true
    },
    NOT_ACTIVATED: (state) => {
        state.status = 'error'
        state.notActivated = true
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
  };